var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPersonFilled = function SvgPersonFilled(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9C20 11.7575 17.7575 14 15 14C12.2425 14 10 11.7575 10 9C10 6.2425 12.2425 4 15 4C17.7575 4 20 6.2425 20 9Z",
    fill: "#1D2E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88359 17.6997C10.4722 16.7574 12.6311 16.1016 14.9996 16.1016C17.3681 16.1016 19.5271 16.7574 21.1156 17.6997C21.9095 18.1706 22.5861 18.7281 23.0737 19.3377C23.5558 19.9404 23.8996 20.6548 23.8996 21.4181C23.8996 22.3626 23.1712 22.8878 22.5814 23.1539C21.9623 23.4333 21.1617 23.5947 20.342 23.6967C18.6968 23.9016 16.6527 23.9016 15.0323 23.9016H14.9669C13.3465 23.9016 11.3024 23.9016 9.65726 23.6967C8.83749 23.5947 8.03695 23.4333 7.41779 23.1539C6.82807 22.8878 6.09961 22.3626 6.09961 21.4181C6.09961 20.6548 6.44339 19.9404 6.92549 19.3377C7.41316 18.7281 8.08971 18.1706 8.88359 17.6997Z",
    fill: "#1D2E69"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person-filled.b92783da.svg";
export { ForwardRef as ReactComponent };